import { getStoredToken, isTokenExpired } from './tokenUtils';
import { getJobsLandingPath } from './routingUtils';

export const getAuthenticatedDashboardPath = () => {
  const profileStr = localStorage.getItem('profile');
  if (!profileStr) return null;

  try {
    const profile = JSON.parse(profileStr);
    const token = profile?.token || getStoredToken();
    if (!token || isTokenExpired(token)) return null;

    if (profile?.result?.role === 'superadmin') {
      return '/dashboard/superadmin';
    }

    const companySlug =
      localStorage.getItem('currentCompanySlug') ||
      profile?.result?.slug ||
      profile?.result?.companySlug ||
      profile?.slug;

    return getJobsLandingPath(companySlug);
  } catch {
    return null;
  }
};
